/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsScenarioViewModel } from './InvestmentDetailsScenarioViewModel';
import {
    InvestmentDetailsScenarioViewModelFromJSON,
    InvestmentDetailsScenarioViewModelFromJSONTyped,
    InvestmentDetailsScenarioViewModelToJSON,
} from './InvestmentDetailsScenarioViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsViewModel
 */
export interface InvestmentDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsViewModel
     */
    proposalId: number;
    /**
     * 
     * @type {Array<InvestmentDetailsScenarioViewModel>}
     * @memberof InvestmentDetailsViewModel
     */
    scenarios: Array<InvestmentDetailsScenarioViewModel>;
}

/**
 * Check if a given object implements the InvestmentDetailsViewModel interface.
 */
export function instanceOfInvestmentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "scenarios" in value;

    return isInstance;
}

export function InvestmentDetailsViewModelFromJSON(json: any): InvestmentDetailsViewModel {
    return InvestmentDetailsViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'scenarios': ((json['Scenarios'] as Array<any>).map(InvestmentDetailsScenarioViewModelFromJSON)),
    };
}

export function InvestmentDetailsViewModelToJSON(value?: InvestmentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'Scenarios': ((value.scenarios as Array<any>).map(InvestmentDetailsScenarioViewModelToJSON)),
    };
}

